import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoCard } from 'core/components';
import { PhoneNumber } from 'core/elements';
import { getAddressToDisplay, getValue } from 'core/utils';
import {
  ContactGroupAddressType,
  UpdateQuoteAddress,
} from 'quotes/components/CustomerQuoteDetails/Tabs/CustomerQuoteBaseInformation';
import { QuoteEntityType } from 'quotes/enums';
import { ICustomerQuote } from 'quotes/types';

interface IProps {
  quote: ICustomerQuote;
  updateQuote: (updatedQuote?: ICustomerQuote) => void;
  entityType?: QuoteEntityType;
  isEditable?: boolean;
}

export const SoldToInfo = ({
  quote,
  updateQuote,
  entityType = QuoteEntityType.QUOTE,
  isEditable = true,
}: IProps) => {
  const [isEditOpen, setIsEditOpen] = useState<boolean>(false);

  const { t } = useTranslation();

  const handleOnClose = (updatedQuote?: ICustomerQuote) => {
    setIsEditOpen(false);
    updateQuote(updatedQuote);
  };

  return (
    <>
      <InfoCard
        title={QuoteEntityType.QUOTE === entityType ? t('titleQuotedTo') : t('titleSoldTo')}
        items={[
          {
            label: getValue(quote, 'customerContactGroup.name') as string,
            value: [
              getValue(quote, 'customerContactName'),
              <PhoneNumber
                key="customerContactPhone"
                phone={getValue(quote, 'customerContactPhone') as string}
              />,
            ],
          },
          {
            label: getValue(quote, 'soldToAddress.name') as string,
            value: getAddressToDisplay(quote?.soldToAddress),
          },
        ]}
        onEdit={() => setIsEditOpen(true)}
        isEditable={isEditable}
      />

      <UpdateQuoteAddress
        isOpen={isEditOpen}
        quote={quote}
        onClose={handleOnClose}
        addressType={ContactGroupAddressType.SOLD_TO}
      />
    </>
  );
};
